// The customer name as a link to that customer's page (Sales > Customers > Directory > profile). Plain text when there is no partner id or the
// role cannot see Sales (the Customers pages live under it). A real <a> via the router: same-tab click, Ctrl/Cmd-click opens a new tab, keyboard + focus ring.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../context/AuthContext';
import { lineText } from '../../shell/ActionIcons';

import { emoText } from '../../shell/EmojiIcons';
// nav: optional detail tab to land on (47293: 'goodwill' = Goodwill & compensation), carried as ?nav= which CustomersTab reads.
export default function CustomerLink({ id, name, className = '', nav = '' }) {
  const { t } = useTranslation('sales'); const isVisible = React.useContext(AuthContext)?.isVisible;   // a bare drawer mount (no provider) keeps the link; the app always has one
  const label = name || '—';
  if (!id || !name || (isVisible && !isVisible('sales'))) return <>{emoText(label)}</>;
  return <Link className={`cust-link ${className}`} to={`/sales/customers/directory/${encodeURIComponent(id)}${nav ? `?nav=${nav}` : ''}`} title={t('openCustomer')} data-testid="customer-link" onClick={e => e.stopPropagation()}>{lineText(label)}</Link>;
}
